import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import AuthProvider from './context/AuthProvider';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Header from './components/Home/Header/Header';
import Footer from './components/Home/Footer/Footer';
import Home from './components/Home/Home/Home';
import Signin from './components/Home/Signin/Signin';
import Register from './components/Home/Register/Register';
import NotFound from './components/Home/NotFound/NotFound';
import Tours from './components/Home/Tours/Tours';
import TourBooking from './components/Home/TourBooking/TourBooking';
import MyBooking from './components/Home/MyBooking/MyBooking';
import ManageBooking from './components/Home/ManageBooking/ManageBooking';
import AddTour from './components/Home/AddTour/AddTour';
import AddService from './components/Home/AddService/AddService';
import ManageServices from './components/Home/ManageServices/ManageServices';
import MyServiceRequests from './components/Home/MyServiceRequests/MyServiceRequests';
import ManageServiceRequests from './components/Home/ManageServiceRequests/ManageServiceRequests';

function App() {
  return (
    <div  className="App mb-0 w-100">
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Header />
          <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/home' element={<Home />} />
              <Route path='/signin' element={<Signin />} />
              <Route path='/register' element={<Register />} />
              <Route path='/tours' element={<Tours />} />
              <Route path="/tourbooking" element={<PrivateRoute><TourBooking /></PrivateRoute>} />
              <Route path="/tourbooking/:tourId" element={<PrivateRoute><TourBooking /></PrivateRoute>} />
              <Route path="/myBooking" element={<PrivateRoute><MyBooking /></PrivateRoute>} />
              <Route path="/manageBooking" element={<PrivateRoute><ManageBooking /></PrivateRoute>} />
              <Route path="/addTour" element={<PrivateRoute><AddTour /></PrivateRoute>} />
              
              <Route path="/addService" element={<PrivateRoute><AddService /></PrivateRoute>} />
              <Route path="/manageServices" element={<PrivateRoute><ManageServices /></PrivateRoute>} />
              <Route path="/myServiceRequests" element={<PrivateRoute><MyServiceRequests /></PrivateRoute>} />
              <Route path="/manageServiceRequests" element={<PrivateRoute><ManageServiceRequests /></PrivateRoute>} />

              <Route path='*' element={<NotFound />} />
          </Routes>
          <Footer />
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
